import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
	GET_ADMIN_PHASE_TRANSITIONS,
	SG_GET_ADMIN_PHASE_TRANSITIONS,
	FETCH_ADMIN_PHASE_TRANSITION,
	SG_FETCH_ADMIN_PHASE_TRANSITION,
	ADD_ADMIN_PHASE_TRANSITION,
	SG_ADD_ADMIN_PHASE_TRANSITION,
	EDIT_ADMIN_PHASE_TRANSITION,
	SG_EDIT_ADMIN_PHASE_TRANSITION,
	DELETE_ADMIN_PHASE_TRANSITION,
	SG_DELETE_ADMIN_PHASE_TRANSITION,
} from "constants/actions";

/* Admin Phase Transitions */

function* loadPhaseTransitions(action) {
	try {
		const json = yield call(api.GET_APV2_PHASE_TRANSITIONS, action.payload);
		yield put({ type: GET_ADMIN_PHASE_TRANSITIONS, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* phaseTransitionsLoad() {
	yield takeLatest(SG_GET_ADMIN_PHASE_TRANSITIONS, loadPhaseTransitions);
}

function* fetchPhaseTransition(action) {
	try {
		const json = yield call(api.FETCH_APV2_PHASE_TRANSITION, action.payload);
		yield put({ type: FETCH_ADMIN_PHASE_TRANSITION, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* phaseTransitionFetch() {
	yield takeLatest(SG_FETCH_ADMIN_PHASE_TRANSITION, fetchPhaseTransition);
}

function* addPhaseTransition(action) {
	try {
		const json = yield call(api.ADD_APV2_PHASE_TRANSITION, action.payload);
		yield put({ type: ADD_ADMIN_PHASE_TRANSITION, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* phaseTransitionAdd() {
	yield takeLatest(SG_ADD_ADMIN_PHASE_TRANSITION, addPhaseTransition);
}

function* editPhaseTransition(action) {
	try {
		const json = yield call(api.EDIT_APV2_PHASE_TRANSITION, action.payload);
		yield put({ type: EDIT_ADMIN_PHASE_TRANSITION, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* phaseTransitionEdit() {
	yield takeLatest(SG_EDIT_ADMIN_PHASE_TRANSITION, editPhaseTransition);
}

function* deletePhaseTransition(action) {
	try {
		const json = yield call(api.DELETE_APV2_PHASE_TRANSITION, action.payload);
		yield put({ type: DELETE_ADMIN_PHASE_TRANSITION, payload: json.data });
	} catch (e) {
		yield call(handleError, e);
	}
}

export function* phaseTransitionDelete() {
	yield takeLatest(SG_DELETE_ADMIN_PHASE_TRANSITION, deletePhaseTransition);
}

export default function* index() {
	yield all([
		phaseTransitionsLoad(),
		phaseTransitionFetch(),
		phaseTransitionAdd(),
		phaseTransitionEdit(),
		phaseTransitionDelete(),
	]);
}
